"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayEncoding = void 0;
const Utils_1 = require("../../../utils/Utils");
exports.StringArrayEncoding = Utils_1.Utils.makeEnum({
    None: 'none',
    Base64: 'base64',
    Rc4: 'rc4'
});
